import { api } from '../api/client.js';

// Users (JCH — Accounts and groups). Talks to /api/v1/users, which is a
// JCH-only route on the backend. The client.js interceptor attaches the JWT.

export function listUsers() {
  return api.get('/users').then((r) => r.data.data);
}

export function getUser(id) {
  return api.get(`/users/${id}`).then((r) => r.data.data);
}

export function createUser(payload) {
  const normalized = {
    ...payload,
    email: payload.email ?? payload.emailer ?? payload.invitationEmail ?? '',
  };
  delete normalized.emailer;
  delete normalized.invitationEmail;
  if (normalized.role === 'Makler') delete normalized.username;
  return api.post('/users', normalized).then((r) => r.data.data);
}

export function updateUser(id, payload) {
  const normalized = { ...payload };
  if (normalized.emailer && !normalized.email) {
    normalized.email = normalized.emailer;
  }
  delete normalized.emailer;
  delete normalized.invitationEmail;
  return api.patch(`/users/${id}`, normalized).then((r) => r.data.data);
}

// Role enum — must match the backend ROLES on the users route.
export const ROLES = ['JCH', 'JR', 'Makler'];
// Status enum — must match the backend STATUSES on the users route.
export const STATUSES = ['active', 'inactive', 'on_leave', 'terminated'];

export const ROLE_LABEL = {
  JCH: 'JCH',
  JR: 'JR',
  Makler: 'Makler',
};

export const STATUS_LABEL = {
  active: 'Aktivní',
  inactive: 'Neaktivní',
  on_leave: 'Na volné noze',
  terminated: 'Ukončený',
};
